import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, ControllerProps, FieldError } from 'react-hook-form';

type FormTextFieldProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
  name: string;
  control: Control<any, any>;
  error?: FieldError;
  rules?: ControllerProps['rules'];
  required?: boolean;
};

export function FormTextField({ name, control, error, rows, rules, ...props }: FormTextFieldProps) {
  const isMultiline = Number(rows ?? 0) > 1;
  const isDate = props.type === 'date';
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextField
          {...props}
          {...field}
          value={field.value ?? ''}
          error={!!error}
          helperText={error?.message}
          size="small"
          InputLabelProps={isDate ? { shrink: true } : props.InputLabelProps}
          sx={{
            width: isMultiline ? '100%' : 'auto',
            borderRadius: 2,
            ...(props.sx as object),
          }}
          InputProps={{
            style: {
              borderRadius: 0,

              fontSize: '0.875rem',
            },
            ...props.InputProps,
          }}
        />
      )}
    />
  );
}

export default FormTextField;
